import React from 'react'
import { useDispatch } from 'react-redux'
import { loadSchedulerSettings, updateSchedulerSettings } from 'app/settings/components/Scheduler/actions'
import { SchedulerSettings } from '@cbgms/api/modules/scheduler/scheduler-settings'
import { PUTSchedulerSettingsRequest } from '@cbgms/api/modules/scheduler'

interface SchedulerService {
  loadSchedulerSettings(): Promise<SchedulerSettings>

  updateSchedulerSettings(schedulerSettings: PUTSchedulerSettingsRequest): Promise<string>
}

export const useSchedulerSettingsService = (): SchedulerService => {
  const dispatch = useDispatch()

  const loadSchedulerSettingsFunc = React.useCallback(async () => {
    const { Data } = await dispatch(loadSchedulerSettings())

    return Data
  }, [dispatch])

  const updateSchedulerSettingsFunc = React.useCallback(
    async (settings: PUTSchedulerSettingsRequest) => {
      const { Data } = await dispatch(updateSchedulerSettings(settings))

      return Data.UUID
    },
    [dispatch]
  )

  return {
    loadSchedulerSettings: loadSchedulerSettingsFunc,
    updateSchedulerSettings: updateSchedulerSettingsFunc
  }
}
